import React from 'react';
import { StanButton } from '@/components';
import IcCheckCircle from '@/assets/icons/ic-check-circle.svg';
import { getMFADescription, getMFATitle, MFAConfigSource } from '../../../constants/mfa';

interface MFACompleteProps {
    source: MFAConfigSource;
    onComplete: () => void;
}

export const MFAComplete: React.FC<MFACompleteProps> = ({ source, onComplete }) => {
    const title = getMFATitle('complete', source);
    const description = getMFADescription('complete', source);

    return (
        <div className='flex flex-col items-center text-center'>
            {/* Header */}
            <div className='mb-4 flex flex-col items-center'>
                <IcCheckCircle className='stroke-brand-main mb-4 size-12' style={{ strokeWidth: '2px' }} />
                <h3 className='mb-2'>{title}</h3>
                <h3 className='mb-2'>Your account is now much safer</h3>
                <p className='text-gray text-body-sm'>{description}</p>
            </div>

            {/* Complete Button */}
            <StanButton name='mfa-complete-button' className='mt-6 w-full' size='md' onClick={onComplete}>
                Awesome!
            </StanButton>
        </div>
    );
};
